module.exports = {
  paymentProccessing: 'Processing of payment started.',
  paymentSuccessful: 'Payment marked as successful.',
  transactionCancel: 'Cancellation of transaction started.',
  reRegistration: 'Re-registration Successful',
  dataRedy: 'Your data is ready for',
  wallet: 'Wallet: Update successful!',
  order: 'Order',
  thankYuou: 'Thank you for your order!',
  yourOrderNuber: 'Your order number is:',
  created_successfully: 'created successfully!',
  updated_successfully: 'updated successfully!',
  companySettingsRefreshed: 'Company settings refreshed successfully!',
  catalogRefreshed: 'Catalog refreshed successfully!',
  sendSuccess: 'Your request was sent. You will receive an email shortly!',
  addressUpdated: 'Address info updated',
  addedToCart: 'was added',
  postalSet: 'Postal code set! Click Calculate to see if there are delivery charges.',
  deliveryCalculated: 'Delivery charges calculated successfully.',
  registrationSuccessfully: 'Registration successful. You will receive activation email shortly',
  passSuccess: 'Password set successfully. You are now logged in.',
  thankYou: 'Thank you for your order! Please check your mailbox and spam folder for the confirmation.',
  paymentOrderOk: 'Order paid successfully!',
  visitOk: 'Visit successfully registered.',
  rateOk: 'Thank you! Your opinion is important to us.',
  continueTo: 'Continue to',
  blacklist: 'Blacklist: entry added successfully.',
};



// WEBPACK FOOTER //
// ./src/lang/en/success.js